module.exports = __webpack_public_path__ + "img/cycle.41555f87.svg";